<template>
  <div class="big-form-container">
    <!-- heading -->
    <header id="big-form-header-edit" style="justify-content: space-between" class="big-form-header">
      <div style="display: flex; align-items: center">
        <button @click="backNavigate" class="back-button">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 6H1M1 6L6 11M1 6L6 1"
              stroke="#1A1A1A"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <h2>Detail Data Karyawan</h2>
      </div>

      <router-link
        style="text-decoration: none; color: inherit"
        custom
        :to="`/hrd/edit-karyawan/${docId}`"
      >
        <button id="yellow-button-2" class="yellow-button">Edit data</button>
      </router-link>
    </header>
    <!-- end of heading -->

    <!-- main form -->
    <div class="box-big-form">
      <!-- section foto -->
      <section class="form-section">
        <h3 class="section-title">Foto</h3>
        <!-- upload foto -->
        <label
          style="position: relative"
          ref="fileBox"
          for="file-upload"
          class="custom-file-upload"
        >
          <img
            class="preview-image"
            :src="urlFotoProfil"
            style="object-fit: cover"
            ref="preview"
            alt
          />
          <span ref="uploadText">upload</span>
        </label>
        <!-- end of upload foto -->
      </section>
      <!-- end of section foto -->
      <hr />

      <section class="form-section">
        <h3 class="section-title">Data diri</h3>
        <!-- form data diri -->
        <div class="list-form tambah-karyawan">
          <!-- input nama lengkap -->
          <div ref="nama-form" class="box-form email">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.7147 13.4284V11.9999C12.7147 11.2421 12.4137 10.5154 11.8779 9.97956C11.342 9.44374 10.6153 9.14272 9.85756 9.14272H4.14328C3.38551 9.14272 2.65879 9.44374 2.12297 9.97956C1.58715 10.5154 1.28613 11.2421 1.28613 11.9999V13.4284M9.85756 3.42843C9.85756 5.00639 8.57837 6.28557 7.00042 6.28557C5.42246 6.28557 4.14328 5.00639 4.14328 3.42843C4.14328 1.85048 5.42246 0.571289 7.00042 0.571289C8.57837 0.571289 9.85756 1.85048 9.85756 3.42843Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="dataDiri.namaLengkap" class="input-title"
                >Nama Lengkap</span
              >
              <input
                disabled
                v-model="dataDiri.namaLengkap"
                class="input-text"
                required
                placeholder="Nama lengkap"
                type="text"
              />
            </div>
          </div>
          <!-- input no hp -->
          <div ref="nohp-form" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28613 5.69253H12.7147M1.28613 10.3079H12.7147M5.57185 1.07715L4.14328 14.9233M9.85756 1.07715L8.42899 14.9233"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="dataDiri.noHp" class="input-title">No HP</span>
              <input
                disabled
                v-model="dataDiri.noHp"
                class="input-text"
                required
                placeholder="No HP"
                type="number"
              />
            </div>
          </div>

          <!-- input tempat lahir -->
          <div ref="tempat-lahir-form" class="box-form email">
            <svg
              width="14"
              height="18"
              viewBox="0 0 14 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="dataDiri.tempatLahir" class="input-title"
                >Tempat lahir</span
              >
              <input
                disabled
                v-model="dataDiri.tempatLahir"
                class="input-text"
                required
                placeholder="Tempat lahir"
                type="text"
              />
            </div>
          </div>
        </div>

        <div class="list-form tambah-karyawan">
          <!-- tanggal lahir -->
          <label
            ref="tanggal-lahir-form"
            tabindex="0"
            for="date-picker-lahir"
            class="box-form email"
          >
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div style="position: relative" class="input-and-title">
              <span class="input-title">Tanggal lahir</span>
              <input
                disabled
                style="width: 200px; height: 50px"
                @change="inputChanged($event)"
                id="date-picker-lahir"
                class="date-control"
                type="date"
                v-model="dataDiri.tanggalLahir"
              />
              <p>
                {{
                  dataDiri.tanggalLahir
                    ? dataDiri.tanggalLahir
                    : "Tanggal lahir"
                }}
              </p>
            </div>
          </label>

          <!-- input alamat -->
          <div ref="alamat-form" style="width: 542px" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.857 15.1431V8.00028H9.14272V15.1431M0.571289 5.85742L6.99986 0.857422L13.4284 5.85742V13.7146C13.4284 14.0934 13.2779 14.4568 13.01 14.7247C12.7421 14.9926 12.3787 15.1431 11.9999 15.1431H1.99986C1.62098 15.1431 1.25762 14.9926 0.989708 14.7247C0.721799 14.4568 0.571289 14.0934 0.571289 13.7146V5.85742Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="dataDiri.alamat" class="input-title">Alamat</span>
              <input
                disabled
                v-model="dataDiri.alamat"
                class="input-text"
                required
                placeholder="Alamat"
                type="text"
              />
            </div>
          </div>
        </div>

        <!-- end of form data diri -->
      </section>
      <hr />
      <!-- form data kepegawaian -->
      <section class="form-section">
        <h3 class="section-title">Data kepegawaian</h3>

        <div class="list-form tambah-karyawan">
          <!-- input no pegawai -->
          <div ref="no-pegawai-form" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28613 5.69253H12.7147M1.28613 10.3079H12.7147M5.57185 1.07715L4.14328 14.9233M9.85756 1.07715L8.42899 14.9233"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="dataKepegawaian.noPegawai" class="input-title"
                >No Pegawai</span
              >
              <input
                disabled
                v-model="dataKepegawaian.noPegawai"
                class="input-text"
                required
                placeholder="No Pegawai"
                type="number"
              />
            </div>
          </div>
          <!-- end of input no pegawai -->

          <!-- input cabang -->
          <div style="position: relative" class="keterangan">
            <div ref="cabang-form" class="box-form email">
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="dataKepegawaian.cabang"
                  style="display: block"
                  class="input-title"
                  >Cabang</span
                >
                <p>
                  {{
                    dataKepegawaian.cabang ? dataKepegawaian.cabang : "Cabang"
                  }}
                </p>
              </div>
            </div>
          </div>
          <!-- end of input cabang -->

          <!-- input divisi -->
          <div style="position: relative" class="keterangan">
            <div ref="divisi-form" class="box-form email">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857422 11.5717L8.00028 15.1431L15.1431 11.5717M0.857422 8.00028L8.00028 11.5717L15.1431 8.00028M8.00028 0.857422L0.857422 4.42885L8.00028 8.00028L15.1431 4.42885L8.00028 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="dataKepegawaian.divisi"
                  style="display: block"
                  class="input-title"
                  >Divisi</span
                >
                <p>
                  {{
                    dataKepegawaian.divisi ? dataKepegawaian.divisi : "Divisi"
                  }}
                </p>
              </div>
            </div>
          </div>
          <!-- end of input divisi -->
        </div>

        <div class="list-form tambah-karyawan">
          <!-- input jabatan -->
          <div style="position: relative" class="keterangan">
            <div ref="jabatan-form" class="box-form email">
              <svg
                width="16"
                height="14"
                viewBox="0 0 16 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.8574 13.4284V1.99986C10.8574 1.62098 10.7069 1.25762 10.439 0.989708C10.1711 0.721799 9.80773 0.571289 9.42885 0.571289H6.57171C6.19283 0.571289 5.82946 0.721799 5.56156 0.989708C5.29365 1.25762 5.14314 1.62098 5.14314 1.99986V13.4284M2.28599 3.42843H13.7146C14.5035 3.42843 15.1431 4.06803 15.1431 4.857V11.9999C15.1431 12.7888 14.5035 13.4284 13.7146 13.4284H2.28599C1.49702 13.4284 0.857422 12.7888 0.857422 11.9999V4.857C0.857422 4.06803 1.49702 3.42843 2.28599 3.42843Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="dataKepegawaian.jabatan"
                  style="display: block"
                  class="input-title"
                  >Jabatan</span
                >
                <p>
                  {{
                    dataKepegawaian.jabatan
                      ? dataKepegawaian.jabatan
                      : "Jabatan"
                  }}
                </p>
              </div>
            </div>
          </div>
          <!-- end of input jabatan -->

          <!-- tanggal mulai bekerja -->
          <label
            ref="mulai-form"
            tabindex="0"
            for="date-picker-lahir"
            class="box-form email"
          >
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div style="position: relative" class="input-and-title">
              <span class="input-title">Mulai bekerja</span>
              <input
                disabled
                style="width: 200px; height: 50px"
                id="date-picker-lahir"
                class="date-control"
                type="date"
                v-model="dataKepegawaian.mulaiBekerja"
              />
              <p>
                {{
                  dataKepegawaian.mulaiBekerja
                    ? dataKepegawaian.mulaiBekerja
                    : "Mulai bekerja"
                }}
              </p>
            </div>
          </label>
          <!-- end of tanggal mulai bekerja -->

          <!-- input status -->
          <div style="position: relative" class="keterangan">
            <div ref="status-form" class="box-form email">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.7147 13.4284V11.9999C12.7147 11.2421 12.4137 10.5154 11.8779 9.97956C11.342 9.44374 10.6153 9.14272 9.85756 9.14272H4.14328C3.38551 9.14272 2.65879 9.44374 2.12297 9.97956C1.58715 10.5154 1.28613 11.2421 1.28613 11.9999V13.4284M9.85756 3.42843C9.85756 5.00639 8.57837 6.28557 7.00042 6.28557C5.42246 6.28557 4.14328 5.00639 4.14328 3.42843C4.14328 1.85048 5.42246 0.571289 7.00042 0.571289C8.57837 0.571289 9.85756 1.85048 9.85756 3.42843Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="dataKepegawaian.status"
                  style="display: block"
                  class="input-title"
                  >Status</span
                >
                <p>
                  {{
                    dataKepegawaian.status ? dataKepegawaian.status : "Status"
                  }}
                </p>
              </div>
            </div>
          </div>
          <!-- end of status -->
        </div>
      </section>
      <hr />
      <section class="form-section">
        <h3 class="section-title">Data penggajian</h3>
        <div class="list-form tambah-karyawan">
          <!-- input nama bank -->
          <div ref="nama-bank-form" class="box-form email">
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.14258 5.57185H16.8569M2.57115 1.28613H15.4283C16.2173 1.28613 16.8569 1.92573 16.8569 2.7147V11.2861C16.8569 12.0751 16.2173 12.7147 15.4283 12.7147H2.57115C1.78217 12.7147 1.14258 12.0751 1.14258 11.2861V2.7147C1.14258 1.92573 1.78217 1.28613 2.57115 1.28613Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="dataPenggajian.namaBank" class="input-title"
                >Bank</span
              >
              <input
                disabled
                v-model="dataPenggajian.namaBank"
                class="input-text"
                required
                placeholder="Bank"
                type="text"
              />
            </div>
          </div>
          <!-- end of input nama bank -->

          <!-- input no rekening -->
          <div ref="no-rekening-form" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28613 5.69253H12.7147M1.28613 10.3079H12.7147M5.57185 1.07715L4.14328 14.9233M9.85756 1.07715L8.42899 14.9233"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="dataPenggajian.noRekening" class="input-title"
                >No rekening</span
              >
              <input
                disabled
                v-model="dataPenggajian.noRekening"
                class="input-text"
                required
                placeholder="No rekening"
                type="number"
              />
            </div>
          </div>
          <!-- end of input no rekening -->

          <!-- input besaran gaji -->
          <div ref="besaran-gaji-form" class="box-form email">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.25665 7.79369H14.7323M1.25665 9.39141H14.7323M1.25665 11.0193H14.7323M15.1242 5.92454C15.1845 6.07527 15.0941 6.19586 14.9434 6.19586H1.07585C0.894966 6.19586 0.834678 6.07527 0.864825 5.92454L2.58319 1.25179C2.64348 1.10106 2.82437 0.980469 2.9751 0.980469H12.8331C12.9838 0.980469 13.1949 1.10106 13.2552 1.25179L15.1242 5.92454ZM9.72805 3.4225C9.84864 4.26661 9.06483 4.99013 7.97954 4.99013C6.89426 4.99013 6.11044 4.23646 6.17074 3.4225C6.26118 2.66883 7.04499 2.12619 7.91925 2.12619C8.82365 2.12619 9.63761 2.69897 9.72805 3.4225ZM4.57657 3.53886C4.62046 3.84611 4.33515 4.10948 3.94011 4.10948C3.54507 4.10948 3.25976 3.83514 3.2817 3.53886C3.31462 3.26452 3.59993 3.067 3.91816 3.067C4.24737 3.067 4.54365 3.27549 4.57657 3.53886ZM12.6227 3.53886C12.6666 3.84611 12.3813 4.10948 11.9863 4.10948C11.5912 4.10948 11.3059 3.83514 11.3279 3.53886C11.3608 3.26452 11.6461 3.067 11.9643 3.067C12.2935 3.067 12.5898 3.27549 12.6227 3.53886Z"
                stroke="#A0A3BD"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="dataPenggajian.besaranGaji" class="input-title"
                >Besaran gaji</span
              >
              <input
                disabled
                v-model="dataPenggajian.besaranGaji"
                class="input-text"
                required
                placeholder="Besaran gaji"
                type="number"
              />
            </div>
          </div>
          <!-- end of input besaran gaji -->
        </div>
      </section>
      <!-- end of form data kepegawaian -->
      <hr />
      <section class="form-section">
        <div class="header-section-riwayat">
          <h3 class="section-title">Riwayat</h3>
        </div>

        <!-- tabel riwayat -->
        <div class="box-table table-riwayat-karir">
          <table>
            <tr>
              <th>Jenjang Karir</th>
              <th>Cabang</th>
              <th>Awal</th>
              <th>Akhir</th>
            </tr>
            <!-- start iterasi tabel -->
            <tr :key="index" v-for="(riwayat, index) in listRiwayat">
              <!-- jenjang karir -->
              <td>
                <span style="color: #1d1d1d; font-weight: 700">{{
                  riwayat.jabatan
                }}</span>
                <br />
                <span>{{ riwayat.divisi }}</span>
              </td>
              <!-- cabang -->
              <td>{{ riwayat.cabang }}</td>
              <!-- awal -->
              <td>{{ riwayat.awal }}</td>
              <!-- akhir -->
              <td>{{ riwayat.akhir }}</td>
            </tr>
            <!-- end iterasi tabel -->
          </table>
          <p class="empty-state-table" v-if="listRiwayat.length === 0">
            Tidak ada data
          </p>
        </div>
        <!-- end of tabel riwayat -->
      </section>
    </div>
    <!-- end of main form -->
  </div>
</template>

<script>
import * as soluhafire from "@/soluhafire";

export default {
  data() {
    return {
      docId: this.$route.params.id,
      // variabel form
      profilePicture: null,
      dataDiri: {
        namaLengkap: "",
        noHp: "",
        tempatLahir: "",
        tanggalLahir: "",
        alamat: "",
      },
      dataKepegawaian: {
        noPegawai: "",
        cabang: "",
        divisi: "",
        jabatan: "",
        mulaiBekerja: "",
        status: "",
        kehadiran: "aktif",
      },
      dataPenggajian: {
        namaBank: "",
        noRekening: "",
        besaranGaji: "",
      },
      listRiwayat: [],
      // variabel tambah riwayat
      jabatanSekarang: null,
      dataRiwayat: {
        jabatan: "",
        divisi: "",
        cabang: "",
        awal: null,
        akhir: null,
      },
      urlFotoProfil: null,
    };
  },

  methods: {
    // navigasi kembali
    backNavigate() {
      this.$router.go(-1);
    },
    async getDetailKaryawan() {
      let docRef = await soluhafire.getKaryawan(this.docId);
      docRef.get().then((doc) => {
        let data = doc.data();
        this.urlFotoProfil = data.fotoProfil;
        this.dataDiri = data.dataDiri;
        this.dataKepegawaian = data.dataKepegawaian;
        this.dataPenggajian = data.dataPenggajian;
        this.listRiwayat = data.riwayat;

        // style ketika preview foto profile
        this.$refs.preview.style.width = "141px";
        this.$refs.preview.style.height = "141px";
        this.$refs.preview.style.borderRadius = "8px";
        this.$refs.uploadText.style.display = "none";
      });
    },
  },

  mounted() {
    this.getDetailKaryawan();
  },
};
</script>

<style scoped>
@import url("../../assets/css/hrd/tambahKaryawan.css");
.failed-box-form {
  border-color: #eb5757;
}

.failed-box-form * {
  color: #eb5757;
  stroke: #eb5757;
}
</style>
